import type {
  DistrictSchoolLevelType,
  SchoolType,
} from "@/providers/store/api/find-my-school/find-my-school.interface";
import { isSchoolLevelType, sortSchoolLevelTypeStrings } from "@/shared/utils/school-level-display.utils";

export interface FindMySchoolCategoryTab {
  key: SchoolType;
  label: string;
}

const SCHOOL_LEVEL_TAB_LABELS: Record<DistrictSchoolLevelType, string> = {
  ELEMENTARY: "Elementary",
  MIDDLE: "Middle",
  HIGH: "High",
  K8: "K-8",
};

export function buildFindMySchoolCategoryTabs(
  schoolLevelTypes: readonly DistrictSchoolLevelType[],
): FindMySchoolCategoryTab[] {
  const orderedTypes = sortSchoolLevelTypeStrings(schoolLevelTypes).filter(isSchoolLevelType);

  return [
    { key: "all", label: "All schools" },
    ...orderedTypes.map((type) => ({
      key: type,
      label: SCHOOL_LEVEL_TAB_LABELS[type],
    })),
  ];
}
